//所有保存的枚举数据

export function User(cache) {
  User.prototype._UserCallbackFunc_ = function () {};
  User.prototype.cache = cache;
  User.prototype.USERINFO_KEY = "_USERINFO_KEY_";
}

User.prototype.callback = function (callback) {
  if (typeof callback == "function") {
    this._UserCallbackFunc_ = callback;
    return;
  }
  throw new Error("无效参数，类型:function(){return {};}返回一个数组");
};

User.prototype.getCallbackFunc = function () {
  return this._UserCallbackFunc_;
};
User.prototype.save = function (u) {
  if (!u) {
    return;
  }
  this.set(u);
};
User.prototype.set = function (u,v) {
  if (!u && !v) {
    return;
  }
  if (u && !v) {
    this.cache.set(this.USERINFO_KEY, u);
    return;
  }
  let vx = this.cache.get(this.USERINFO_KEY);
  vx[u] = v;
  this.cache.set(this.USERINFO_KEY, vx);
};


User.prototype.get = function (k) {
  if (!k) {
    return this.getObj();
  }
  let obj = this.getObj();
  return obj[k] || (obj.raw || {})[k];
};

User.prototype.getObj = function () {
  let obj = this.cache.get(this.USERINFO_KEY);
  if (obj) {
    return obj;
  }
  var handle = this.getCallbackFunc();
  var u = handle.apply(this);
  this.set(u);
  return u;
};
